/* oxlint-disable react/only-export-components */
import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

const App = lazy(() => import('@/App'));
const Login = lazy(() => import('@/pages/Login'));
const SignUp = lazy(() => import('@/pages/SignUp'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const ForgotPasswd = lazy(() => import('@/pages/ForgotPasswd'));

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
  },
  {
    path: '/sign',
    element: <Login />,
  },
  {
    path: '/register',
    element: <SignUp />,
  },
  {
    path: '/forgotPassword',
    element: <ForgotPasswd />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
]);

export default router;
